import { inject } from '@angular/core';
import { Router } from '@angular/router';
import type { CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import type { TipoUsuario } from '../models/sesion.model';

const ESPERA = '/vendedor/espera';

/**
 * tipoGuard('VENDEDOR' | 'INTERNO') — va después de authGuard.
 * - Un usuario de otro tipo se manda a su propia área.
 * - Vendedor PENDIENTE_APROBACION → /vendedor/espera (SPEC §8.2). SUSPENDIDO entra en modo
 *   solo lectura: lo resuelve cada pantalla deshabilitando acciones (CLAUDE.md §4).
 */
export const tipoGuard = (tipo: Exclude<TipoUsuario, 'SISTEMA'>): CanActivateFn => {
  return (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const actual = auth.tipo();

    if (actual !== tipo) {
      if (actual === 'VENDEDOR') return router.createUrlTree(['/vendedor']);
      if (actual === 'INTERNO') return router.createUrlTree(['/admin']);
      return router.createUrlTree(['/']);
    }

    if (tipo === 'VENDEDOR') {
      const pendiente = auth.vendedor()?.estado === 'PENDIENTE_APROBACION';
      const enEspera = state.url.startsWith(ESPERA);
      // Mientras espera la aprobación solo ve la espera y su cuenta (cambiar contraseña, salir)
      if (pendiente && !enEspera && !state.url.startsWith('/vendedor/cuenta')) return router.createUrlTree([ESPERA]);
      if (!pendiente && enEspera) return router.createUrlTree(['/vendedor']);
    }

    return true;
  };
};
